// extracted by mini-css-extract-plugin
module.exports = {"inner":"Page_inner__2ZM6W"};